import { useState } from "react";
import { Pitch } from "@/components/Pitch";
import { EVENT_TYPES, eventNumbers } from "@/lib/events";
import { useIsMobile } from "@/lib/useMobile";

const QuickBtn = ({ testId, onClick, children }) => (
  <button data-testid={testId} onClick={onClick} className="tap h-8 px-3 border border-white/20 text-xs font-bold uppercase tracking-wider hover:bg-white/10">
    {children}
  </button>
);

export const ReportMap = ({ match }) => {
  const isMobile = useIsMobile();
  const nums = eventNumbers(match);
  const located = match.events.filter((e) => e.x != null);
  const types = EVENT_TYPES.filter((t) => located.some((e) => e.type === t.key));
  const [sel, setSel] = useState(() => new Set(types.map((t) => t.key)));
  const [team, setTeam] = useState("all");
  const [player, setPlayer] = useState("");
  const toggle = (k) => setSel((s) => { const n = new Set(s); n.has(k) ? n.delete(k) : n.add(k); return n; });
  const players = team === "all" ? [] : [...new Set(located.filter((e) => e.team === team && e.target_type === "player" && e.target).map((e) => e.target))]
    .sort((a, b) => +a - +b);
  const markers = located
    .filter((e) => sel.has(e.type) && (team === "all" || e.team === team) && (!player || (e.target_type === "player" && e.target === player)))
    .map((e) => ({ ...e, n: nums[e.id] }));
  const pickTeam = (t) => { setTeam(t); setPlayer(""); };
  const selectCls = "h-9 bg-[#0A0A0A] border border-white/20 px-2 text-sm focus:outline-none focus:border-[#CCFF00]";

  return (
    <div className="border border-white/15 bg-[#131313] p-4 sm:p-6">
      <div className="hidden md:flex justify-between label-caps mb-3"><span>← {match.home.name}</span><span>Mapa de eventos · {markers.length}</span><span>{match.away.name} →</span></div>
      <p className="md:hidden label-caps text-center mb-2">↑ {match.home.name} · {markers.length} eventos</p>
      <div className="mx-auto max-w-[340px] md:max-w-none">
        <Pitch markers={markers} vertical={isMobile} testId="report-pitch" />
      </div>
      <p className="md:hidden label-caps text-center mt-2">{match.away.name} ↓</p>
      <div className="flex flex-wrap items-center gap-2 mt-5">
        <select data-testid="map-filter-team" value={team} onChange={(e) => pickTeam(e.target.value)} className={selectCls}>
          <option value="all">Ambas as equipas</option>
          <option value="home">{match.home.name}</option>
          <option value="away">{match.away.name}</option>
        </select>
        <select data-testid="map-filter-player" value={player} onChange={(e) => setPlayer(e.target.value)} disabled={team === "all"} className={`${selectCls} disabled:opacity-40`}>
          <option value="">{team === "all" ? "Escolha a equipa para filtrar jogador" : "Todos os jogadores"}</option>
          {players.map((p) => <option key={p} value={p}>Nº {p}</option>)}
        </select>
      </div>
      <div className="flex flex-wrap gap-2 mt-3">
        <QuickBtn testId="map-filter-all" onClick={() => setSel(new Set(types.map((t) => t.key)))}>Todos</QuickBtn>
        <QuickBtn testId="map-filter-none" onClick={() => setSel(new Set())}>Nenhum</QuickBtn>
        <QuickBtn testId="map-filter-disc" onClick={() => setSel(new Set(types.filter((t) => t.group === "disc").map((t) => t.key)))}>Só disciplina</QuickBtn>
      </div>
      <div data-testid="map-filters" className="flex flex-wrap gap-2 mt-3">
        {types.map((t) => {
          const on = sel.has(t.key);
          return (
            <button key={t.key} data-testid={`map-filter-${t.key}`} onClick={() => toggle(t.key)} aria-pressed={on}
              className={`tap h-9 pl-2 pr-3 flex items-center gap-2 border text-xs font-semibold ${on ? "border-white/40 text-white bg-white/5" : "border-white/10 text-zinc-600"}`}>
              <span className="w-3 h-3 rounded-full" style={{ background: on ? t.color : "transparent", border: `2px solid ${t.color}` }} />
              {t.label} <span className="text-zinc-500 tabular-nums">{located.filter((e) => e.type === t.key).length}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
